type TourTranslate = (key: string) => string;

export const getAssessmentSectionsDashboardSteps = (t: TourTranslate) => [
  {
    selector: `[data-tour="ad-timer"]`,
    content: t("assessment.tour.shared.timer")
  },
  {
    selector: `[data-tour="ad-legend"]`,
    content: t("assessment.tour.dashboard.legend")
  },
  {
    selector: `[data-tour="ad-sectionCard"]`,
    content: t("assessment.tour.dashboard.sectionCard")
  },
  {
    selector: `[data-tour="ad-submitBtn"]`,
    content: t("assessment.tour.shared.submit")
  }
];

export const getAssessmentCodingQuestionPageSteps = (t: TourTranslate) => [
  {
    selector: `[data-tour="acq-titles"]`,
    content: t("assessment.tour.coding.titles")
  },
  {
    selector: `[data-tour="ad-timer"]`,
    content: t("assessment.tour.shared.timer")
  },
  {
    selector: `[data-tour="acq-sectionsBtn"]`,
    content: t("assessment.tour.coding.sectionsButton")
  },
  {
    selector: `[data-tour="acq-submitBtn"]`,
    content: t("assessment.tour.shared.submit")
  },
  {
    selector: `[data-tour="acq-sidebar"]`,
    content: t("assessment.tour.coding.sidebar")
  },
  {
    selector: `[data-tour="acq-question"]`,
    content: t("assessment.tour.coding.questionCard")
  },
  {
    selector: `[data-tour="acq-editor"]`,
    content: t("assessment.tour.coding.editor")
  }
];
